import { render, staticRenderFns } from "./GerarRelatorioPretendentes.vue?vue&type=template&id=2d0f3b7f&scoped=true&"
import script from "./GerarRelatorioPretendentes.vue?vue&type=script&lang=js&"
export * from "./GerarRelatorioPretendentes.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatorioPretendentes.vue?vue&type=style&index=0&id=2d0f3b7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f3b7f",
  null
  
)

export default component.exports